import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Login from "../pages/login";
import Register from "../pages/register";
import App from "../App";
import Navbar from "../components/navbar";
import Home from "../pages/home";
import Footer from "../components/footer";
import TrainingTrack from "../pages/trackOverview";
import CourseOverview from "../pages/courseOverview";
import CourseView from "../pages/coursePage";
import TrackCoursesPage from "../pages/TrackCoursesPage";
import TracksPage from "../pages/tracks-page";
import Payment from "../pages/payment";

function PrivateRoute({ children }) {
  const authUser = localStorage.getItem("user");
  if (!authUser) {
    return <Navigate to="/login" />;
  } else if (`${window.location.pathname}` === "/") {
    return <Navigate to="/" />;
  }
  return children;
}

export const router = () => {
  const authUser = localStorage.getItem("user");
  return createBrowserRouter(
    createRoutesFromElements(
      <Route>
        {/* <Route
          path="/app/sa"
          element={
            <PrivateRoute>
              <Navbar />
              <App />
              <Footer />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/"
          element={
            <>
              <Navbar authUser={authUser} />
              <Home />
              <Footer />
            </>
          }
        />
        <Route
          path="/track/:trackId/courses"
          element={
            <PrivateRoute>
              <Navbar authUser={authUser} />
              <TrackCoursesPage />
              <Footer />
            </PrivateRoute>
          }
        />
        <Route
          path="/course/:courseId"
          element={
            <PrivateRoute>
              <Navbar authUser={authUser} />
              <CourseOverview />
              <Footer />
            </PrivateRoute>
          }
        />
        <Route
          path="/course-view/:courseId"
          element={
            <PrivateRoute>
              <Navbar authUser={authUser} />
              <CourseView />
              <Footer />
            </PrivateRoute>
          }
        />

        <Route
          path="/payment/:trackId"
          element={
            <PrivateRoute>
              <Navbar authUser={authUser} />
              <Payment />
              <Footer />
            </PrivateRoute>
          }
        />
        <Route
          path="/track/:trackId"
          element={
            // <PrivateRoute>
            <>
              <Navbar authUser={authUser} />
              <TrainingTrack />
              <Footer />
            </>
            // </PrivateRoute>
          }
        />
        <Route
          path="/tracks"
          element={
            // <PrivateRoute>
            <>
              <Navbar authUser={authUser} />
              <TracksPage />
              <Footer />
            </>
            // </PrivateRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>
    )
  );
};
